export const AUTO_ATTR_KEY = 'data-testid' as const

export const setAutoId = (id: string) => ({
  [AUTO_ATTR_KEY]: `${id}`
})

export const AutomationId = {
  dashboard: {
    main: 'dashboard-main',
    controller: 'dashboard-controller',
    report: {
      button: 'dashboard-report-button',
      subscribeButton: 'dashboard-report-subscribe-button',
      unSubscribeButton: 'dashboard-report-unsubscribe-button'
    }
  },
  widget: {
    header: 'widget-header',
    grid: 'widget-grid'
  },
  table: {
    header: 'table-header',
    row: 'table-row',
    cell: 'table-cell',
    footer: 'table-footer',
    footerRow: 'table-footer-row'
  },
  groupTable: {
    body: 'group-table-body',
    divider: 'group-table-divider',
    footerRow: 'group-table-footer-row'
  },
  author: {
    name: 'author-name',
    handle: 'author-handle'
  },
  tile: {
    container: 'tile-container',
    title: 'tile-title',
    value: 'tile-value',
    variationIcon: 'tile-variation-icon',
    variationValue: 'tile-variation-value'
  },
  mediaCard: {
    item: 'media-card',
    footerTooltip: {
      metricsName: 'metrics-name',
      metricsValue: 'metrics-value'
    }
  },
  soundbiteDefaultFrame: {
    date: 'soundbite-date',
    text: 'soundbite-text',
    post: 'soundbite-post',
    mediaIcon: 'soundbite-media-icon',
    authorName: 'soundbite-author-name',
    authorHandle: 'soundbite-author-handle',
    subreddit: 'soundbite-subreddit',
    title: 'soundbite-title',
    vocComingSoon: 'soundbite-voc-coming-soon',
    vocContent: 'soundbite-voc-content',
    vocTag: 'soundbite-voc-tag',
    loadMore: 'soundbite-load-more',
    sharedInfo: 'shared-info',
    warningInfo: 'warning-info',
    actionItems: 'action-items',
    metadata: 'metadata',
    quote: 'quote',
    styledButton: 'styled-button',
    domainLink: 'domain-link',
    domainIcon: 'domain-icon',
    annotationNote: 'annotation-note',
    mediaGrid: 'media-grid'
  },
  compactSoundbiteDefaultFrame: {
    post: 'compact-soundbite-post',
    actionItems: 'compact-soundbite-action-items',
    photoUserTagContent: 'compact-soundbite-photo-user-tag-content'
  },
  bubble: {
    priorMessage: 'bubble-prior-message'
  },
  error: {
    message: 'error-message'
  },
  metricGrid: {
    item: 'metric-grid-item',
    legend: {
      name: 'metric-grid-legend-name',
      value: 'metric-grid-legend-value',
      percentage: 'metric-grid-legend-percentage'
    },
    container: 'metric-grid-container'
  },
  header: 'header-widget',
  link: {
    more: `link-more`
  },
  message: {
    voc: 'message-voc'
  },
  insightChart: {
    insight: 'insight-chart-insight',
    average: 'insight-chart-average',
    total: 'insight-chart-total',
    label: 'insight-chart-label',
    value: 'insight-chart-value'
  },
  popularMedia: {
    authorName: 'popular-media-author-name',
    authorHandle: 'popular-media-author-handle',
    postDate: 'popular-media-post-date',
    metrics: 'popular-media-metrics'
  },
  modal: {
    title: 'modal-title',
    actions: 'modal-actions'
  },
  pdfExport: {
    button: 'pdf-export-button',
    mask: 'pdf-export-mask',
    icon: 'pdf-export-icon',
    maskMessage: 'pdf-export-mask-message'
  },
  tooltip: {
    header: {
      text: 'tooltip-header-text'
    },
    body: {
      left: 'tooltip-body-left',
      right: 'tooltip-body-right'
    }
  },
  insightModal: {
    selectedTerm: 'insight-modal-selected-term',
    selectedTopic: 'insight-modal-selected-topic',
    selectedPivot: 'insight-modal-selected-pivot',
    selectedColumn: 'insight-modal-selected-column',
    vs: 'insight-modal-vs',
    goToAnalysisButton: 'insight-modal-go-to-analyze-button',
    annotationButton: 'insight-modal-annotation-button',
    insightContent: {
      overview: {
        title: 'insight-modal-insight-content-overview-title',
        selectedTerm: 'insight-modal-insight-content-overview-selected-term',
        count: 'insight-modal-insight-content-overview-count',
        percentOfTotal: 'insight-modal-insight-content-overview-percent-of-total'
      },
      soundbite: {
        sortByContainer: 'insight-modal-insight-content-soundbite-sort-by-container',
        warningMessage: 'insight-modal-insight-content-soundbite-warning-message'
      },
      topAuthor: {
        leftHeader: 'insight-modal-insight-content-top-author-left-header',
        rightHeader: 'insight-modal-insight-content-top-author-right-header',
        follower: 'insight-modal-insight-content-top-author-follower',
        simpleBar: 'insight-modal-insight-content-top-author-simple-bar',
        noAuthorFound: 'insight-modal-insight-content-top-author-no-author-found',
        noData: 'insight-modal-insight-content-top-author-no-data'
      },
      topicComparison: {
        allTopics: 'insight-modal-insight-content-topic-comparison-all-topics',
        selectedTopic: 'insight-modal-insight-content-topic-comparison-selected-topic',
        impressions: 'insight-modal-insight-content-topic-comparison-impressions',
        passionIntensity: 'insight-modal-insight-content-topic-comparison-passion-intensity',
        netSentiment: 'insight-modal-insight-content-topic-comparison-net-sentiment'
      }
    },
    and: 'insight-modal-and'
  },
  liveReportModal: {
    generateReportToggleContainer: 'live-report-modal-generate-report-toggle-container',
    enableProtectionToggleContainer: 'live-report-modal-enable-protection-toggle-container',
    label: {
      generateReport: 'live-report-modal-label-generate-report',
      reportLink: 'live-report-modal-label-report-link',
      enableProtection: 'live-report-modal-label-enable-protection',
      reportKey: 'live-report-modal-label-report-key',
      subscribers: 'live-report-modal-label-subscribers'
    },
    warningDialog: 'live-report-modal-warning-dialog',
    reportKeyContainer: 'live-report-modal-report-key-container',
    reportKeyValidationContainer: 'live-report-modal-report-key-validation-container',
    reportLinkContainer: 'live-report-modal-report-link-container',
    subscribersContainer: 'live-report-modal-subscribers-container',
    authorizedReminder: 'live-report-modal-authorized-reminder',
    limitedDashboardReminder: 'live-report-modal-limited-dashboard-reminder'
  },
  systemMessage: {
    logo: 'system-message-logo',
    title: 'system-message-title',
    content: 'system-message-content',
    footer: 'system-message-footer'
  },
  liveReport: {
    login: {
      title: 'live-report-login-title',
      errorMessage: 'live-report-login-error-message',
      email: 'live-report-login-email',
      reportKey: 'live-report-login-report-key',
      button: 'live-report-login-button'
    },
    title: 'live-report-title',
    logoutButton: 'live-report-logout-button',
    watermark: 'live-report-watermark',
    legalReminder: 'live-report-legal-reminder',
    copyright: 'live-report-copyright'
  },
  actionList: {
    breadcrumb: 'action-list-breadcrumb'
  },
  sidePannel: {
    category: 'side-pannel-category',
    searchBox: 'side-pannel-search-box',
    labelTitle: 'side-pannel-label-title',
    dashboardTitle: 'side-pannel-dashboard-title',
    label: 'side-pannel-label',
    labelSubtitle: 'side-pannel-label-subtitle',
    labelSelected: 'side-pannel-label-selected',
    dashboard: 'side-pannel-dashboard',
    filterPill: 'side-pannel-filter-pill',
    selectedTitle: 'side-pannel-selected-title',
    additionalTitle: 'side-pannel-additional-title',
    noResultsFound: 'side-pannel-no-results-found',
    noDataFound: 'side-pannel-no-data-found',
    noDataFoundImg: 'side-pannel-no-data-found-img'
  },
  dashboardInfo: {
    field: 'dashboard-info-field',
    value: 'dashboard-info-value'
  },
  menu: {
    itemTitle: 'menu-item-title'
  },
  popularlinks: {
    linkItem: 'popular-links-link-item',
    topLink: 'popular-links-top-link',
    bottomItem: 'popular-links-bottom-item',
    hideMentionsButton: 'popular-links-hide-mentions-button'
  },
  photoConcept: {
    card: 'photo-concept-card',
    deletedCard: 'photo-concept-deleted-card',
    previewNotAvailable: 'photo-concept-preview-not-available',
    authorName: 'photo-concept-author-name',
    authorHandle: 'photo-concept-author-handle',
    retweetedAuthor: 'photo-concept-retweeted-author'
  },
  scheduledReport: {
    modal: {
      label: {
        frequency: 'scheduled-report-modal-label-frequency',
        mode: 'scheduled-report-modal-label-mode',
        at: 'scheduled-report-modal-label-at',
        and: 'scheduled-report-modal-label-and',
        every: 'scheduled-report-modal-label-every',
        subscribers: 'scheduled-report-modal-label-subscribers'
      },
      content: {
        frequency: 'scheduled-report-modal-content-frequency',
        mode: 'scheduled-report-modal-content-mode',
        at: 'scheduled-report-modal-content-at',
        and: 'scheduled-report-modal-content-and',
        every: 'scheduled-report-modal-content-every',
        subscribers: 'scheduled-report-modal-content-subscribers',
        delayWarning: 'scheduled-report-modal-content-delay-warning'
      },
      limitedDashboardReminder: 'scheduled-report-modal-limited-dashboard-reminder'
    }
  },
  fluctuationSummary: {
    metrics: 'fluctuation-summary-metrics',
    popularTerms: 'fluctuation-summary-popular-terms',
    popularTermsHeader: 'fluctuation-summary-popular-terms-header',
    popularTermsItem: 'fluctuation-summary-popular-terms-item'
  },
  annotation: {
    list: 'annotation-list'
  }
} as const
